import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectOutput } from 'core/http/dev';

export interface UpdateExtensionProjectsDialogData {
  enabledProjects: ProjectOutput[];
  allProjects: ProjectOutput[];
}

export interface UpdateExtensionProjectsDialogResult {
  enabledProjects: ProjectOutput[];
}

@Component({
  selector: 'app-update-extension-projects-dialog',
  templateUrl: './update-extension-projects-dialog.component.html',
  styleUrls: ['./update-extension-projects-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UpdateExtensionProjectsDialogComponent {
  name = '';

  get projects(): ProjectOutput[] {
    return this.data.allProjects.filter(p => p.name.toLowerCase().includes(this.name.toLowerCase()));
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: UpdateExtensionProjectsDialogData) { }

  isEnabled(project: ProjectOutput): boolean {
    return this.data.enabledProjects.some(a => a.id === project.id);
  }

  toggleProjectState(event: MatCheckboxChange, project: ProjectOutput): void {
    this.data.enabledProjects = event.checked
      ? this.data.enabledProjects.concat(project)
      : this.data.enabledProjects.filter(p => p.id !== project.id);
  }
}
